module.exports = __webpack_public_path__ + "static/media/Accident.1499c005.svg";